export const queryKeys = {
  EXPO_ALL: 'EXPO_ALL'
};
